module.exports = __webpack_public_path__ + "static/media/forest.8ce20f1f.svg";